import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit {
  title = 'dental';
  
  menuOpened: boolean;
  access = {size: 100, enabled: false};

  accSetSize (size: number) {
    this.access.size = size;
    document.cookie = `access.size=${size}`;
  }

  toggleAccessMode () {
    this.access.enabled = !this.access.enabled;
    document.cookie = `access.enabled=${this.access.enabled}`;
  }  

  ngOnInit () {
    
    let ssize = document.cookie.match('access\.size=(.+);?')
    if (ssize && ssize.length == 2) {
      this.access.size = parseInt(ssize[1]);
    }

    let amode = document.cookie.match('access\.enabled=(.+);?')
    if (amode && amode.length == 2) {
      this.access.enabled = amode[1] == "enabled";
    }

    
  }



  
}
